import { Component, DestroyRef, OnInit } from '@angular/core';
import { DecoratedTransport } from '../../../core/models/DecoratedTransport';
import { TranslocoService } from '@ngneat/transloco';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { LanguageService } from '../../../core/services/language.service';
import { DecoratedFreightDocument } from '../../../core/models/DecoratedFreightDocument'
import { CurrentCompanyService } from '../../../core/services/current-company.service'
import { BehaviorSubject } from 'rxjs'
import { DriverAssignLink } from '../../../core/utils/DriverAssignLink'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-share-carrier-access-code',
  templateUrl: './share-carrier-access-code.component.html',
  standalone: true,
  imports: [SharedModule]
})
export class ShareCarrierAccessCodeComponent implements OnInit {
  transport: DecoratedTransport;
  freightDocument: DecoratedFreightDocument;

  private companyId = new BehaviorSubject<string>(null);
  $companyIdLoaded = this.companyId.asObservable();

  constructor(private readonly route: ActivatedRoute,
              private readonly companyService: CurrentCompanyService,
              private readonly translocoService: TranslocoService,
              private readonly languageService: LanguageService,
              private readonly destoryRef: DestroyRef) {
   if (this.route.snapshot.data.transport != null) {
     this.transport = this.route.snapshot.data.transport;
   }
   if (this.route.snapshot.data.freightDocument != null) {
     this.freightDocument = this.route.snapshot.data.freightDocument;
   }

   this.setLanguage(this.languageService.getSessionLanguage());
  }

  ngOnInit(): void {
    this.companyService.get()
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(company => this.companyId.next(company.mainAccount.encodedId));
  }

  getQrCodeData(): string {
    const codes = this.getAccessCodeList();
    const transportId = this.getTransportId();
    if (!codes || !transportId) {
      return "";
    }

    return DriverAssignLink.transportUrl(window.location.origin, {
      companyId: this.companyId.getValue(),
      transportId: transportId,
      accessCode: codes.at(0)
    }) ?? "";
  }

  getRawQrCodeData(): string {
    const codes = this.getAccessCodeList();
    if (!codes) {
      return "";
    }
    return `${codes.at(0)}`;
  }

  getTransportId(): string {
    if (this.freightDocument) {
      return this.freightDocument.transportId;
    } else {
      return this.transport.id;
    }
  }

  getAccessCodeList(): string[] {
    if (this.freightDocument) {
      return this.freightDocument?.carrierAccessCodes;
    } else {
      return this.transport.carrierAccessCodes;
    }
  }

  close(): void {
    window.self.close();
  }

  private setLanguage(lng: string) {
    this.translocoService.setActiveLang(lng);
  }
}
